import type { MappedTransaction } from "src/interfaces/transaction.interface";
import { deleteBulkInventoryApi } from "./inventories";
import { deleteManySales } from "./sales";
import { deleteTransactions } from "./transactions";

export async function deleteMappedTransactions(
  transactions: Pick<MappedTransaction, "collection" | "collection_id">[]
) {
  const {
    sales,
    transactions: ts,
    items,
  } = transactions.reduce(
    (all, t) => {
      if (t.collection === "sale") all.sales.push(t.collection_id);
      else if (t.collection === "inventory") all.items.push(t.collection_id);
      else if (t.collection === "transaction")
        all.transactions.push(t.collection_id);
      return all;
    },
    {
      sales: [] as string[],
      transactions: [] as string[],
      items: [] as string[],
    }
  );

  return await Promise.all([
    deleteManySales(sales),
    deleteTransactions(ts),
    deleteBulkInventoryApi(items),
  ]);
}
